import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AuthHeader from '../../components/AuthHeader';
import AuthSidebar from '../../components/AuthSidebar';
import AuthFooter from '../../components/AuthFooter';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AodRoundedIcon from '@mui/icons-material/AodRounded';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slice/user';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';

// const location = useLocation()


const MainLayout = ({ children }) => {
  console.log('child', children)
  // const { user } = useAuth();
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [showLeftMenue, setShowLeftMenue] = useState(false)
  const [showAccountMenu, setShowAccountMenu] = useState(false)
  const navigator = useNavigate();
  const location = useLocation();
  const goToProfile = () => {
    console.log('Enrwechhsddh')
    navigator('/user/account');
  };

  const goToEditProfile = () => {
    navigator('/user/edit-profile');
  }
  const goToChangePassword = () => {
    navigator('/user/change-password');
  }

  const goToHelp = () => {
    navigator('/user/help');
  }
  const handleLogout = () => {
    dispatch(logout())
    navigator('/login')
  }
  console.log(user)
  return (
    <div className='body'>
      {/* <div className="adminLayout">
        <div className={showLeftMenue ? "leftPanel show" : "leftPanel"}>

          <button className={showLeftMenue ? "mainDashboard-toggle active" : "mainDashboard-toggle"}
            onClick={() => setShowLeftMenue(!showLeftMenue)}>
            <div></div>
          </button>
          <div className="logoDiv">
            <Link to="/user/dashboard">
              <img src="/images/logo-1.svg" />
            </Link>
          </div>
          <ul>
            <li><Link to="/user/dashboard" className={location.pathname === "/user/dashboard" && "active"}><DashboardOutlinedIcon /> <span>Dashboard</span></Link></li>
          </ul>
        </div>
        <div className="leftPanel-outerlayout" onClick={() => setShowLeftMenue(false)}></div>
        <div className="rightPanel">
          <div className="dashbordHead">
            <div className="dashbordHeadRow">
              <button className={showLeftMenue ? "mainDashboard-toggle active" : "mainDashboard-toggle"} onClick={() => setShowLeftMenue(!showLeftMenue)}>
                <div></div>
              </button>

              <div className="right">
                <div className="profileMenu">
                  <div class="dropdown">
                    <div className="avtarBlock" onClick={() => setShowAccountMenu(!showAccountMenu)}>
                      <div className="imgBlock">
                        <AccountCircleOutlinedIcon />
                      </div>
                      {user &&
                        <p>{user.firstName} {user.lastName}</p>
                      }
                    </div>

                    <ul class={showAccountMenu ? "dropdown-menu show" : "dropdown-menu"} onClick={() => setShowAccountMenu(!showAccountMenu)}>
                      <li class="dropdown-menu-header">
                        <h5>Account</h5>
                        <button class="dropdown-close"><img src="/images/modaclosebtn.svg" alt="" /></button>
                      </li>
                      <li class="userAcountInfo">
                        <figure>
                          <AccountCircleOutlinedIcon />
                          {user &&
                            <figcaption>
                              <h4>{user.firstName} {user.lastName}</h4>
                              <p>{user.email}</p>
                            </figcaption>
                          }
                        </figure>
                      </li>

                      <li><a class="dropdown-item" onClick={goToEditProfile}><EditOutlinedIcon /> Edit Profile</a></li>
                      <li><a class="dropdown-item" onClick={goToChangePassword}><HttpsOutlinedIcon /> Change Password</a></li>
                      <li><a class="dropdown-item" onClick={goToHelp}><SettingsOutlinedIcon /> Help</a></li>
                      <li>
                        <div class="cdivider"></div>
                      </li>
                      <li>
                        <a class="dropdown-item" onClick={() => handleLogout()}><LogoutOutlinedIcon /> Logout</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div> */}


      {children}
      {/* </div>
      </div> */}
    </div >
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;
